(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3359],{

/***/ 37320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_step; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
// EXTERNAL MODULE: ./components/molecules/card-step/CardStep.module.css
var CardStep_module = __webpack_require__(32817);
var CardStep_module_default = /*#__PURE__*/__webpack_require__.n(CardStep_module);
;// CONCATENATED MODULE: ./components/molecules/card-step/CardStep.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        " \n      ",
        "\n      p-6\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        flex flex-col items-center gap-4\n        ",
        " \n        ",
        "\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ref;
/**
 * CardStep
 */ var CardStep = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, pretitle = param.pretitle, title = param.title, subtitle = param.subtitle, description = param.description, button = param.button, image = param.image, _size = param.size, size = _size === void 0 ? "large" : _size, stroke = param.stroke;
    var ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(container/* default */.Z, {
        justify: "justify-start",
        align: "items-center",
        textAlign: "text-center",
        className: (0,es/* oneLine */.f9)(_templateObject(), (CardStep_module_default())["c-card-step"], (CardStep_module_default())["c-card-step--".concat(size)], stroke ? (CardStep_module_default())["c-card-step--stroke"] : "", size === "large" ? "gap-8" : "", size === "small" ? "gap-6" : "", className),
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[140px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.sourceUrl,
                    width: (ref1 = image.mediaDetails) === null || ref1 === void 0 ? void 0 : ref1.width,
                    height: (ref2 = image.mediaDetails) === null || ref2 === void 0 ? void 0 : ref2.height,
                    alt: image.altText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,es/* oneLine */.f9)(_templateObject1(), size === "large" ? "w-[266px]" : "", size === "small" ? "w-[242px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CardStep_module_default())["c-card-step__pretitle"],
                                children: pretitle
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CardStep_module_default())["c-card-step__title"],
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CardStep_module_default())["c-card-step__subtitle"],
                                children: subtitle
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardStep_module_default())["c-card-step__description"],
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    button && button.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                        href: (0,utils/* removeBaseURL */.t7)((ref = button === null || button === void 0 ? void 0 : (ref3 = button.link) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref !== void 0 ? ref : ""),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                            label: button.label,
                            negative: button.negativo,
                            as: "a",
                            style: button.style
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/card-step/index.ts

/* harmony default export */ var card_step = (CardStep);


/***/ }),

/***/ 3359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Stepper": function() { return /* binding */ Stepper; },
  "default": function() { return /* binding */ Stepper_Stepper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
// EXTERNAL MODULE: ./components/molecules/scrolled-grid/ScrolledGrid.module.css
var ScrolledGrid_module = __webpack_require__(14021);
var ScrolledGrid_module_default = /*#__PURE__*/__webpack_require__.n(ScrolledGrid_module);
;// CONCATENATED MODULE: ./components/molecules/scrolled-grid/ScrolledGrid.tsx



/**
 * ScrolledGrid
 */ var ScrolledGrid = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _numCol = param.numCol, numCol = _numCol === void 0 ? 4 : _numCol, _minWidthElement = param.minWidthElement, minWidthElement = _minWidthElement === void 0 ? "var(--card-size-s-w)" : _minWidthElement, _withSteps = param.withSteps, withSteps = _withSteps === void 0 ? false : _withSteps, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ScrolledGrid_module_default())["c-scrolled-grid"], " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ScrolledGrid_module_default())["c-scrolled-grid__scroll"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ScrolledGrid_module_default())["c-scrolled-grid__grid"],
                style: {
                    gridTemplateColumns: "repeat(".concat(numCol, ", minmax(0, 1fr))"),
                    minWidth: "calc(".concat(minWidthElement, " * ").concat(numCol, ")")
                },
                children: (0,utils/* childrenToArray */.QV)(children).map(function(child, index) {
                    return withSteps ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ScrolledGrid_module_default())["c-scrolled-grid__item"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ScrolledGrid_module_default())["c-scrolled-grid__step"],
                                "aria-hidden": "true",
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ScrolledGrid_module_default())["c-scrolled-grid__child"],
                                children: child
                            })
                        ]
                    }, "item-".concat(index)) : child;
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/scrolled-grid/index.ts

/* harmony default export */ var scrolled_grid = (ScrolledGrid);

// EXTERNAL MODULE: ./components/molecules/card-step/index.ts + 1 modules
var card_step = __webpack_require__(37320);
// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
;// CONCATENATED MODULE: ./components/templates/stepper/StepperWordpress.tsx




var _url, ref;
/**
 * StepperWordpress
 */ var StepperWordpress = function(param) {
    var stepper = param.stepper;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-center",
        children: [
            (stepper.pretitulo || stepper.titulo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-4 flex w-full flex-col items-center",
                children: [
                    stepper.pretitulo && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "u-actions--link mb-4 block text-secondary-500",
                        children: stepper.pretitulo
                    }),
                    stepper.titulo && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "u-headline u-headline--h2",
                        children: stepper.titulo
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scrolled_grid, {
                withSteps: true,
                numCol: stepper.steps.length,
                minWidthElement: "290px",
                className: "[&+a]:mt-3 [&+a]:xs:mt-10",
                children: stepper.steps.map(function(step, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(card_step/* default */.Z, {
                        image: step === null || step === void 0 ? void 0 : step.imagen,
                        pretitle: step.subtitulo,
                        title: step.titulo,
                        size: stepper.size,
                        stroke: stepper.stroke,
                        button: step === null || step === void 0 ? void 0 : step.button,
                        description: step === null || step === void 0 ? void 0 : step.descripcion
                    }, index);
                })
            }),
            (stepper === null || stepper === void 0 ? void 0 : stepper.contentAfterSteps) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "u-label u-label--s mb-6 mt-3 flex w-full flex-col items-center justify-center text-center normal-case xs:mt-10 [&>:not(*:last-child)]:mb-2",
                dangerouslySetInnerHTML: {
                    __html: stepper.contentAfterSteps
                }
            }),
            (stepper === null || stepper === void 0 ? void 0 : stepper.label) && (stepper === null || stepper === void 0 ? void 0 : stepper.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                href: (0,utils/* removeBaseURL */.t7)((_url = stepper === null || stepper === void 0 ? void 0 : stepper.link.url) !== null && _url !== void 0 ? _url : ""),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                    label: stepper.label,
                    as: "a",
                    style: (ref = stepper === null || stepper === void 0 ? void 0 : stepper.style) !== null && ref !== void 0 ? ref : "primary",
                    className: "mx-auto min-w-full md:min-w-fit"
                })
            })
        ]
    });
};
StepperWordpress.displayName = "StepperWordpress";

;// CONCATENATED MODULE: ./components/templates/flexible-content/Stepper/Stepper.tsx



/**
 * Stepper
 */ var Stepper = function(param) {
    var bloque = param.bloque, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        id: id,
        wrapper: true,
        as: "section",
        padding: "px-4 py-8",
        backgroundColor: bloque.background ? "bg-".concat(bloque.background) : undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperWordpress, {
            stepper: bloque
        })
    });
};
/* harmony default export */ var Stepper_Stepper = (Stepper);
Stepper.displayName = "FlexibleStepper";


/***/ }),

/***/ 32817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-card-step--small":"CardStep_c-card-step--small__VmFKZ","c-card-step--large":"CardStep_c-card-step--large__WvrL0","c-card-step--stroke":"CardStep_c-card-step--stroke__r3Arc","c-card-step__pretitle":"CardStep_c-card-step__pretitle__fWPMh","c-card-step__title":"CardStep_c-card-step__title__EGnQ1","c-card-step__subtitle":"CardStep_c-card-step__subtitle___6UPA","c-card-step__description":"CardStep_c-card-step__description__T82eH"};

/***/ }),

/***/ 14021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-scrolled-grid":"ScrolledGrid_c-scrolled-grid__AWRPE","c-scrolled-grid__scroll":"ScrolledGrid_c-scrolled-grid__scroll__hQTGY","c-scrolled-grid__grid":"ScrolledGrid_c-scrolled-grid__grid__3NnkP","c-scrolled-grid__step":"ScrolledGrid_c-scrolled-grid__step__RuhLC","c-scrolled-grid__item":"ScrolledGrid_c-scrolled-grid__item__joZ8g","c-scrolled-grid__child":"ScrolledGrid_c-scrolled-grid__child__1HwTf"};

/***/ })

}]);